import React from 'react';
import '../Dashboard/dashboard.css';
import { Link, Outlet, useNavigate } from 'react-router-dom';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import CommentIcon from '@mui/icons-material/Comment';

const Dashboard = () => {
  const navigate = useNavigate();
  const logoutHandler = () => {
    localStorage.clear();
    navigate('/admin/login');
  };

  return (
    <div className='containr'>
      <div className='sidebar'>
        <div className='adminlogo'>
          <h1 className='logoname'>P.K Real Estate</h1>
          <button onClick={logoutHandler} className='logout-btn'><LogoutIcon /> Logout</button>
        </div>
        {/* <Link to='/admin/dashboard' className='link'><DashboardIcon /><span style={{ marginLeft: '10px' }}>Dashboard</span></Link> */}
        <Link to='/admin/dashboard/property' className='link'><ApartmentIcon /><span style={{ marginLeft: '10px' }}>Property List</span></Link>
        <Link to='/admin/dashboard/add-property' className='link'><AddTwoToneIcon /><span style={{ marginLeft: '10px' }}>Add Property</span></Link>
        <Link to='/admin/dashboard/type' className='link'><HomeWorkIcon /><span style={{ marginLeft: '10px' }}>Type List</span></Link>
        <Link to='/admin/dashboard/add-type' className='link'><AddCircleIcon /><span style={{ marginLeft: '10px' }}>Add Type</span></Link>
        <Link to='/admin/dashboard/comment' className='link'><CommentIcon /><span style={{ marginLeft: '10px' }}>Comments</span></Link>
      </div>
      <div className='mainC'>
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;